import React from 'react';

function ServicesUrbanFoundationsSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '80px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF'
    },
    inner: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 64,
      flexWrap: 'wrap'
    },
    leftCol: {
      flex: '1 1 380px',
      maxWidth: 636,
      minWidth: 300,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    },
    rightCol: {
      flex: '1 1 440px',
      maxWidth: 640,
      minWidth: 280
    },
    imageWrap: {
      position: 'relative',
      flex: 1,
      minHeight: 400,
      overflow: 'hidden',
      opacity: 1
    },
    sectionImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'top center',
      display: 'block'
    },
    ctaBtn: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      display: 'inline-block',
      fontFamily: 'Lato',
      fontWeight: 600,
      fontSize: 14,
      padding: '14px 28px',
      background: '#E73123',
      color: '#FFFFFF',
      textDecoration: 'none',
      textTransform: 'uppercase',
      textAlign: 'center'
    },
    overlineRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      marginBottom: 16
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 14,
      lineHeight: '100%',
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineRule: {
      width: 80,
      height: 2,
      background: '#E73123',
      flexShrink: 0
    },
    titleRow: {
      marginBottom: 24
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontStyle: 'normal',
      fontSize: 32,
      lineHeight: 1.2,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: 0
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontStyle: 'normal',
      fontSize: 32,
      lineHeight: 1.2,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: 1.7,
      letterSpacing: 0,
      color: '#838383',
      margin: '0 0 24px 0'
    },
    supportHeading: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontStyle: 'normal',
      fontSize: 20,
      lineHeight: 1.4,
      letterSpacing: 0,
      color: '#E73123',
      margin: '0 0 16px 0'
    },
    supportGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px 32px',
      marginBottom: 24
    },
    supportItem: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: 1.7,
      letterSpacing: 0,
      textTransform: 'capitalize',
      color: '#090909',
      margin: 0,
      paddingLeft: 20,
      position: 'relative'
    },
    bullet: {
      position: 'absolute',
      left: 0,
      top: 14,
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: '#E73123'
    }
  };

  const supportItems = [
    'Commercial towers',
    'Retail complexes',
    'Mixed-use developments',
    'Institutional buildings',
    'Luxury residential apartments'
  ];

  return React.createElement('section', { style: styles.section, className: 'section-padding' },
    React.createElement('div', { style: styles.inner, className: 'section-inner-wrap' },
      React.createElement('div', { style: styles.leftCol, className: 'section-image-col' },
        React.createElement('div', { style: styles.imageWrap, className: 'section-image-wrap' },
          React.createElement('img', {
            src: '/urbanfoundations.jpg',
            alt: 'Urban residential and commercial construction',
            style: styles.sectionImage
          }),
          React.createElement('a', { href: '#contact', style: styles.ctaBtn }, 'REQUEST A CONSULTATION')
        )
      ),
      React.createElement('div', { style: styles.rightCol, className: 'section-text-col' },
        React.createElement('div', { style: styles.overlineRow },
          React.createElement('p', { style: styles.overline }, 'URBAN FOUNDATIONS'),
          React.createElement('div', { style: styles.overlineRule })
        ),
        React.createElement('div', { style: styles.titleRow },
          React.createElement('span', { style: styles.titleRed }, 'RESIDENTIAL &'),
          React.createElement('span', { style: styles.titleBlack }, ' COMMERCIAL DEVELOPMENTS')
        ),
        React.createElement('p', { style: styles.body },
          'From high-rise residential towers to corporate offices and commercial complexes, we provide dependable foundation systems that ensure long-term safety and stability.'
        ),
        React.createElement('h3', { style: styles.supportHeading }, 'Our Services Support:'),
        React.createElement('div', { style: styles.supportGrid },
          supportItems.map(function (item, i) {
            return React.createElement('p', { key: i, style: styles.supportItem },
              React.createElement('span', { style: styles.bullet }),
              item
            );
          })
        ),
        React.createElement('p', { style: styles.body },
          'We combine precision piling methods with efficient project management to deliver cost-effective and timely solutions, meeting the expectations of developers and stakeholders alike.'
        )
      )
    )
  );
}

export default ServicesUrbanFoundationsSection;
